<template>
  <div class="post">
    <van-nav-bar
      :title="topTitle"
      :right-text="lang.topclear"
      :left-arrow="!$route.query.fromapp"
      @click-left="prev()"
      @click-right="clear()"
    />
    <div
      v-show="tipShow && mode!= 'edit'"
      class="tip"
    >
      {{ lang.rentOrSale }}
    </div>
    <!-- 标题 -->
    <div class="tit">
      <span class="num">4</span>
      <span class="titname">{{ lang.propertyprice }}</span>
    </div>
    <!-- Tab切换 -->
    <van-tabs
      id="tabLine"
      v-model="active"
      :line-width="173"
      color="#292630"
      @click="changTabs"
    >
      <!-- 放售价 -->
      <van-tab
        :title="lang.sale"
        :disabled="$route.query.type == 'edit' && saleDisable"
      >
        <van-field
          v-model="sale.salePrice"
          :label="`${lang.sellPrice}(${lang.sellPriceUnit})`"
          input-align="right"
          required
          type="tel"
          @click="post.goPosition($event,$route.query.fromapp)"
          @blur="comSalePrice(sale.salePrice)"
        />
        <!-- 绿白表 是公屋或者居屋&&楼盘类型不是车位显示-->
        <template v-if="sign.greenWhiteShow && !sign.IsParking">
          <van-cell
            is-link
            :title="lang.SaleFrom"
            :value="SaleFormText"
            required
            @click="tableShow=true"
          />
          <van-popup
            v-model="tableShow"
            position="top"
            class="choose"
            :overlay="false"
          >
            <van-nav-bar
              :title="lang.toptitle"
              left-arrow
              :right-text="lang.confirm"
              @click-left="tableShow = false"
              @click-right="tableShow=false"
            />
            <van-radio-group v-model="sale.saleForm">
              <van-cell
                v-for="(item, index) in DSaleForm.children"
                :key="index"
                clickable
                :title="item.dictionaryNameWithCulture"
                @click="selectTable(item)"
              >
                <!-- <van-radio checked-color="#ED1818" :name="item.dictionaryValue" /> -->
                <svg
                  v-if="item.dictionaryValue !== sale.saleForm"
                  class="icon iselected"
                  aria-hidden="true"
                >
                  <use xlink:href="#icon-xuanzhong-norx" />
                </svg>
                <svg
                  v-if="item.dictionaryValue == sale.saleForm"
                  class="icon iselected"
                  aria-hidden="true"
                >
                  <use xlink:href="#icon-gouxuanx" />
                </svg>
              </van-cell>
            </van-radio-group>
          </van-popup>
        </template>
        <!-- 车位 -->
        <van-switch-cell
          v-if="!sign.IsParking"
          v-model="sale.isLinkParking"
          :title="lang.withCarParkL"
          active-color="#FF0000"
          class="car"
        />
        <p
          v-if="!sign.IsParking"
          class="area"
        >
          {{ lang.areaPoint }}
        </p>
        <div class="flex">
          <van-field
            v-if="!sign.IsParking"
            v-model="PropertyInfo.buildingArea"
            :label="lang.buildArea"
            input-align="right"
            required
            type="tel"
            @click="post.goPosition($event,$route.query.fromapp)"
          />
          <van-field
            v-if="!sign.IsParking"
            v-model="PropertyInfo.saleableArea"
            :label="lang.useArea"
            input-align="right"
            type="tel"
            @click="post.goPosition($event,$route.query.fromapp)"
          />
        </div>
        <!-- <div class="spacing">
          <van-switch-cell v-if="!sign.IsParking" v-model="sale.isVerifyArea" :title="lang.reviewArea" active-color="#FF0000" />
        </div> -->
      </van-tab>
      <!-- 放租价 -->
      <van-tab
        :title="lang.rent"
        :disabled="$route.query.type == 'edit' && rentDisable"
      >
        <van-field
          v-model="rent.rentPrice"
          :label="lang.mrentPrice"
          input-align="right"
          required
          type="tel"
          @blur="comSellPrice(rent.rentPrice)"
          @click="post.goPosition($event,$route.query.fromapp)"
        />
        <!-- 起租日 -->
        <van-cell
          is-link
          :title="lang.mrebtData"
          :value="rentDate"
          @click="timePicShow=true"
        />
        <van-popup
          v-model="timePicShow"
          position="bottom"
        >
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            :cancel-button-text="lang.remove"
            :confirm-button-text="lang.confirm"
            @confirm="confirm"
            @cancel="cancel"
          />
        </van-popup>
        <!-- 其它选项 -->
        <van-cell
          v-if="!sign.IsParking"
          :title="lang.otherOps"
          is-link
          :value="rent.rentLabel == undefined || rent.rentLabel == 0? '': rent.rentLabel.length"
          @click="typeShow=true"
        />
        <van-popup
          v-model="typeShow"
          class="choose"
          :overlay="false"
          position="top"
        >
          <van-nav-bar
            :title="lang.otherOps"
            left-arrow
            :right-text="lang.confirm"
            @click-left="typeShow = false"
            @click-right="typeShow=false"
          />
          <van-checkbox-group v-model="rent.rentLabel">
            <van-cell
              v-for="(item, index) in DRentLabel"
              :key="index"
              clickable
              :title="item.dictionaryNameWithCulture"
              @click="toggle(index,item)"
            >
              <van-checkbox
                ref="checkboxes"
                :name="item.dictionaryValue"
                checked-color="#ED1818"
              />
            </van-cell>
          </van-checkbox-group>
        </van-popup>
        <p
          v-if="!sign.IsParking"
          class="area"
        >
          {{ lang.areaPoint }}
        </p>
        <div class="flex">
          <van-field
            v-if="!sign.IsParking"
            v-model="PropertyInfo.buildingArea"
            :label="lang.buildArea"
            input-align="right"
            required
            type="tel"
            @click="post.goPosition($event,$route.query.fromapp)"
          />
          <van-field
            v-if="!sign.IsParking"
            v-model="PropertyInfo.saleableArea"
            :label="lang.useArea"
            input-align="right"
            type="tel"
            @click="post.goPosition($event,$route.query.fromapp)"
          />
        </div>
        <!-- <div class="spacing">
          <van-switch-cell v-if="!sign.IsParking" v-model="rent.isVerifyArea" :title="lang.reviewArea" active-color="#FF0000" />
        </div> -->
      </van-tab>
    </van-tabs>
    <!-- next -->
    <div class="next">
      <van-button
        class="nextBtn"
        @click="prev"
      >
        {{ lang.prev }}
      </van-button>
      <van-button
        class="nextBtn"
        :class="{'opc':VerifyNext}"
        @click="next"
      >
        {{ lang.next }}
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { Dialog, DatetimePicker } from "vant";
import post from "./../../../common/js/post"
import lang from "./../../../common/language/post";
export default {
  name: "Step4",
  data () {
    return {
      mode: '',
      post,
      lang,
      url: document.URL,
      cacheNum: "",
      topTitle: "",
      DSaleForm: "", //綠錶價/白錶價 字典
      SaleFormText: "",
      tableShow: false,
      active: 0,
      typeShow: false,
      timePicShow: false,
      tipShow: false,
      rentDate: lang.rentTime, // 起租日
      currentDate: new Date(),
      DRentLabel: [],
      saleDisable: false, // sale 禁用
      rentDisable: false, // rent 禁用
      query: '',
      PropertyInfo: {
        rentalType: "sale", // 出租 sale 出售
        buildingArea: "", //建筑面积
        saleableArea: "" // 实用面积
      },
      rent: {
        rentPrice: "", //出租价
        beginRentTime: 0, //起租日
        // isVerifyArea: false, //面积是否审核
        rentLabel: [] // 其他选项
      },
      sale: {
        salePrice: "", //放售价
        saleForm: "", //绿表价/白表价
        isLinkParking: false, //是否连车位
        // isVerifyArea: false //面积是否审核
      }
    };
  },
  watch: {
    "rent.beginRentTime" (num) {
      if (num == "" || num == 0 || num == undefined) {
        this.rentDate = this.lang.rentTime
      } else {
        this.rentDate = this.getdate(num);
      }
    },
    "rent.rentLabel" (data) {
      //服务式住宅和商务中心只能二选一
      if (JSON.stringify(data) == "[]" || data === undefined) {
        return;
      }
      let house = data.lastIndexOf("5");
      let Business = data.lastIndexOf("6");
      if (house > -1 && Business > -1) {
        let position = house < Business ? house : Business;
        this.rent.rentLabel.splice(position, 1);
      }
    }
  },
  created () {
    this.topTitle = post.getTitle(this, this.lang)
    this.getDictionary();
    if (this.propertyInfo.rentalType) {
      this.getState();
    }
    post.getQuery(this)
  },
  computed: {
    ...mapState(["propertyInfo", "sign", "dictionary", 'showBtn']),
    VerifyNext () {
      let data = this.PropertyInfo
      let rent = this.rent
      let sale = this.sale
      if (data.rentalType == 'rent' || data.rentalType == 2) {
        if (this.sign.IsParking) { if (rent.rentPrice) {return false} }
        else {
          if (rent.rentPrice && data.buildingArea && data.saleableArea) {
            if (Number(this.PropertyInfo.saleableArea) <= Number(this.PropertyInfo.buildingArea)) {
              return false
            } 
              return true;
            
          } else if (rent.rentPrice && (data.buildingArea || data.saleableArea)) {
            return false
          }

        }
        return true
      } 
        if (this.sign.IsParking) {
          if (sale.salePrice) {return false}
        }
        else if (this.sign.greenWhiteShow) {
          if (this.sale.saleForm && sale.salePrice && data.buildingArea && data.saleableArea) {
            if (Number(this.PropertyInfo.saleableArea) <= Number(this.PropertyInfo.buildingArea)) {
              return false
            } 
              return true;
            
          }
          if (this.sale.saleForm && sale.salePrice && (data.buildingArea || data.saleableArea)) {return false}
        }
        else {
          if (sale.salePrice && data.buildingArea && data.saleableArea) {
            if (Number(this.PropertyInfo.saleableArea) <= Number(this.PropertyInfo.buildingArea)) {
              return false
            } 
              return true;
            
          } else if (sale.salePrice && (data.buildingArea || data.saleableArea)) {
            return false
          }
        }
        return true
      
    }
  },
  methods: {
    ...mapMutations(["setProperty", "stepChange", "clearStep4"]),
    comSellPrice (data) {
      if (post.verifDouble(this.rent.rentPrice)) { this.$notify(lang.require4.rentPrice); return; }
      data = String(data)
      if (this.url.indexOf('en-us') > -1 && data && data.length >= 9) {
        Dialog({ message: `Leasing price of your listing property is ${Math.round(data / 1000000 * 100) / 100} million`, confirmButtonText: 'confrim' });
      }
      else if (this.url.indexOf('zh-cn') > -1 && data && data.length >= 9) {
        Dialog({ message: `你的楼盘放租价是 ${Math.round(data / 100000000 * 100) / 100} 亿元`, confirmButtonText: '确认' });
      }
      else if (data && data.length >= 9) {
        Dialog({ message: `你的樓盤放租價是 ${Math.round(data / 100000000 * 100) / 100} 億元`, confirmButtonText: '確認' });
      }
    },
    comSalePrice (data) {
      if (post.verifDouble(this.sale.salePrice)) { this.$notify(lang.require4.salePrice); return; }
      data = String(data)
      if (this.url.indexOf('en-us') > -1 && data && data.length >= 5) {
        Dialog({ message: `Selling price of your listing property is  ${(data * 1000000 / 1000000) / 100} million`, confirmButtonText: 'confrim' });
      }
      else if (this.url.indexOf('zh-cn') > -1 && data && data.length >= 5) {
        Dialog({ message: `你的楼盘放售价是  ${Math.round(data / 10000 * 100) / 100}  亿元`, confirmButtonText: '确认' });
      }
      else if (data && data.length >= 5) {
        Dialog({ message: `你的樓盤放售價是 ${Math.round(data / 10000 * 100) / 100} 億元`, confirmButtonText: '確認' });
      }
    },
    getState () {
      this.PropertyInfo = Object.assign({}, this.propertyInfo);
      if (JSON.stringify(this.propertyInfo.rentLabel) === "{}") {
        this.rent.rentLabel = [];
      }
      if (this.PropertyInfo.rentalType == "rent" || this.PropertyInfo.rentalType == 2) {
        // 如果刊登或修改没有传递时间 后台返回-28000 处理为0
        if (this.propertyInfo.beginRentTime < 0) { this.propertyInfo.beginRentTime = "" }
        this.rent = Object.assign({},
          {
            rentPrice: this.propertyInfo.rentPrice,
            beginRentTime: this.propertyInfo.beginRentTime,
            // isVerifyArea: this.propertyInfo.isVerifyArea,
            rentLabel: this.propertyInfo.rentLabel
          }
        );
        // console.log(this.rent)

        this.active = 1;
        if (this.rent.rentLabel && this.rent.rentLabel.constructor === Object) {
          let rentLabel = [];
          for (let key in this.rent.rentLabel) {
            rentLabel.push(key);
          }
          this.rent.rentLabel = rentLabel;
        }
        this.saleDisable = true;
      }
      if (
        this.PropertyInfo.rentalType == "sale" ||
        this.PropertyInfo.rentalType == 1
      ) {
        this.sale = Object.assign({}, {
          salePrice: this.propertyInfo.salePrice,
          saleForm: this.propertyInfo.saleForm,
          isLinkParking: this.propertyInfo.isLinkParking,
          // isVerifyArea: this.propertyInfo.isVerifyArea
        }
        );
        this.active = 0;
        if (this.sale.saleForm) {
          this.sale.saleForm = String(this.sale.saleForm);
          this.SaleFormText = this.getDictionaryText(
            this.sale.saleForm,
            this.DSaleForm.children
          );
        } // 如果有绿表盘选项
        this.rentDisable = true;
      }
    },
    getDictionary () {
      for (let key in this.dictionary) {
        if (key == "SaleForm") {
          this.DSaleForm = this.dictionary[key];
        }
        if (key == "RentLabel") {
          this.DRentLabel = this.dictionary[key].children;
        }
      }
    },
    getDictionaryText (value, Dictionary) {
      if (typeof value == "object") {
        let textArr = [];
        for (let i = 0; i < value.length; i++) {
          textArr.push(
            this.Dictionary.filter(item => item.dictionaryValue == value[i])[0]
              .dictionaryNameWithCulture
          );
        }
        return textArr.join(",");
      } 
        return Dictionary.find(item => {
          if (item.dictionaryValue == value) {
            return item;
          }
        }).dictionaryNameWithCulture;
      
    },
    changTabs (index, title) {
      this.tipShow = true;
      if (index === 0) {
        this.PropertyInfo.rentalType = "sale";
        this.rent = {};
      } else {
        this.PropertyInfo.rentalType = "rent";
        this.sale = {};
        this.SaleFormText = "";
      }
      setTimeout(() => {
        this.tipShow = false;
      }, 1000);
    },
    getdate (now) {
      now = new Date(now);
      let y = now.getFullYear();
      let m = now.getMonth() + 1;
      let d = now.getDate();
      return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
    },
    confirm (nowtime) {
      this.timePicShow = false;
      this.rent.beginRentTime = new Date(nowtime).getTime();
      this.rentDate = this.getdate(nowtime);
    },
    selectTable (item) {
      if (this.sale.saleForm == item.dictionaryValue) {
        this.sale.saleForm = "";
        this.SaleFormText = "";
      } else {
        this.sale.saleForm = item.dictionaryValue;
        this.SaleFormText = item.dictionaryNameWithCulture;
      }
    },
    cancel () {
      this.timePicShow = false;
      this.rentDate = this.lang.rentTime;
      this.rent.beginRentTime = 0;
    },
    prev () {
      if (
        this.PropertyInfo.rentalType === "rent" ||
        this.PropertyInfo.rentalType == 2
      ) {
        this.setProperty({ ...this.PropertyInfo, ...this.rent });
      }
      if (
        this.PropertyInfo.rentalType === "sale" ||
        this.PropertyInfo.rentalType == 1
      ) {
        this.setProperty({ ...this.PropertyInfo, ...this.sale });
      }
      this.$router.push('/post/step3/' + this.query)
      this.stepChange(3);
    },
    next () {
      if (this.validate_required()) {
        if (
          this.PropertyInfo.rentalType === "rent" ||
          this.PropertyInfo.rentalType == 2
        ) {
          this.setProperty({ ...this.rent, ...this.PropertyInfo });
        }
        if (
          this.PropertyInfo.rentalType === "sale" ||
          this.PropertyInfo.rentalType == 1
        ) {
          this.setProperty({ ...this.sale, ...this.PropertyInfo });
        }
        this.$router.push('/post/step5/' + this.query)
        this.stepChange(5);
      }
    },
    clear () {
      Dialog.confirm({
        title: lang.Clearcontent,
        cancelButtonText: lang.cancel,
        confirmButtonText: lang.confirm
      })
        .then(() => {
          //  1.清空 vuex 中的数据
          this.clearStep4();
          //  2. 清空本页面的v-model 的数据
          this.PropertyInfo.buildingArea = "";
          this.PropertyInfo.saleableArea = "";
          if (
            this.PropertyInfo.rentalType === "rent" ||
            this.PropertyInfo.rentalType == 2
          ) {
            this.rent.rentPrice = "";
            this.rent.beginRentTime = "";
            // this.rent.isVerifyArea = false;
            this.$set(this.rent, "rentLabel", []);
            this.rentDate = this.lang.rentTime;
          }
          if (
            this.PropertyInfo.rentalType == "sale" ||
            this.PropertyInfo.rentalType == 1
          ) {
            this.sale.salePrice = "";
            this.sale.isLinkParking = false;
            // this.sale.isVerifyArea = false;
            this.sale.saleForm = "";
            this.SaleFormText = "";
          }
        })
        .catch(() => { });
    },
    validate_required () {
      if (this.PropertyInfo.rentalType === "rent" || this.PropertyInfo.rentalType == 2) {
        // 如果类型为车位 就只验证租金
        if (this.sign.IsParking) {
          if (!this.rent.rentPrice || this.rent.rentPrice == '') {
            this.$notify(lang.require4.rent);
            return;
          }
          if (post.verifDouble(this.rent.rentPrice)) {
            this.$notify(lang.require4.rentPrice);
            return;
          }
          this.setProperty(this.PropertyInfo);
          this.setProperty({
            rentPrice: this.rent.rentPrice,
            beginRentTime: this.rent.beginRentTime
          });
          return true;
        }
        if (!this.rent.rentPrice || this.rent.rentPrice == '') {
          this.$notify(lang.require4.rent);
          return;
        }
        if (post.verifDouble(this.rent.rentPrice)) {
          this.$notify(lang.require4.rentPrice);
          return;
        }
        if (this.PropertyInfo.buildingArea == '' && this.PropertyInfo.saleableArea == '') {
          this.$notify(lang.require4.Area);
          return;
        }
        if (post.verifDouble(this.PropertyInfo.buildingArea)) {
          this.$notify(lang.require4.buildArea);
          return;
        }
        if (post.verifDouble(this.PropertyInfo.saleableArea)) {
          this.$notify(lang.require4.saleArea);
          return;
        }
        if ((this.PropertyInfo.saleableArea && this.PropertyInfo.buildingArea) && Number(this.PropertyInfo.saleableArea) > Number(this.PropertyInfo.buildingArea)) {
          this.$notify(lang.areaTip);
          return;
        }
        this.PropertyInfo = { ...this.PropertyInfo, ...this.rent };
        this.setProperty(this.PropertyInfo);
        return true;
      }
      // 售校验规则
      if (this.PropertyInfo.rentalType === "sale" || this.PropertyInfo.rentalType == 1) {
        if (this.sign.IsParking) {
          if (!this.sale.salePrice || this.sale.salePrice == '') {
            this.$notify(lang.require4.sale);
            return;
          }
          if (post.verifDouble(this.sale.salePrice)) {
            this.$notify(lang.require4.salePrice);
            return;
          }
          this.setProperty(this.PropertyInfo);
          this.setProperty({ salePrice: this.sale.salePrice });
          return true;
        }
        if (!this.sale.salePrice || this.sale.salePrice == '') {
          this.$notify(lang.require4.sale);
          return;
        }
        if (post.verifDouble(this.sale.salePrice)) {
          this.$notify(lang.require4.salePrice);
          return;
        }
        if (this.sign.greenWhiteShow && !this.sale.saleForm) {
          this.$notify(lang.require4.SaleForm);
          return;
        }
        if (this.PropertyInfo.buildingArea == '' && this.PropertyInfo.saleableArea == '') {
          this.$notify(lang.require4.Area);
          return;
        }
        if (post.verifDouble(this.PropertyInfo.buildingArea)) {
          this.$notify(lang.require4.buildArea);
          return;
        }
        if (post.verifDouble(this.PropertyInfo.saleableArea)) {
          this.$notify(lang.require4.saleArea);
          return;
        }
        if ((this.PropertyInfo.saleableArea && this.PropertyInfo.buildingArea) && Number(this.PropertyInfo.saleableArea) > Number(this.PropertyInfo.buildingArea)) {
          this.$notify(lang.areaTip);
          return;
        }
        this.PropertyInfo = { ...this.PropertyInfo, ...this.sale };
        this.setProperty(this.PropertyInfo);
        return true;
      }
    },
    toggle (index, item) {
      this.$refs.checkboxes[index].toggle();
    }
  },
  filters: {
    time (val) {
      let day = new Date(val);
      let y = day.getFullYear();
      let m = day.getMonth() + 1;
      let d = day.getDate();
      return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
    }
  },
  beforeDestroy () {
    this.PropertyInfo = { ...this.PropertyInfo, ...this.sale, ...this.rent };
    this.setProperty({ ...this.PropertyInfo });
  },
  component: {
    [DatetimePicker.name]: DatetimePicker
  }
};
</script>

<style lang="scss" scoped>
.opc {
  opacity: 0.5;
}
.car {
  position: relative;
  // z-index: 100
}
.iselected {
  font-size: 22px;
}
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.flex {
  display: flex;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: 600;
}
.van-nav-bar__text {
  color: #333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
.area {
  font-size: 14px;
  color: #999999;
  height: 45px;
  line-height: 45px;
  padding-left: 16px;
}
.setp4 {
  text-align: left;
  background-color: #f6f7f8;
  height: 100%;
}
@keyframes myfirst {
  from {
    opacity: 0.9;
  }
  50% {
    opacity: 0.8;
  }
  to {
    opacity: 0;
  }
}

.tip {
  animation: myfirst 3s;
  text-align: center;
  background-color: rgb(0, 0, 0);
  color: #fff;
  font-size: 12px;
  height: 32px;
  line-height: 32px;
  position: fixed;
  width: 100%;
  top: 47px;
  left: 0;
  // opacity: 0;
}
.spacing {
  margin-top: 16px;
}
/deep/ .van-field__label {
  max-width: 100px;
  span {
    display: inline-block;
    width: 100px;
  }
}
.choose {
  height: 100%;
  width: 100%;
  background-color: #f5f6f7;
}
</style>
